export default __webpack_public_path__ + "static/media/logo.0c0b17f3.svg";